import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import { FormControlLabel } from "../../Default/LekUI/Checkbox";
import Filter from "./DefaultFilters";

export default function QuestionLevelsFilter(props) {
	const { t } = useTranslation();

	const setSelectedType = (level) => {
		if (props.selectedData.level.includes(level)) {
			props.setSelectedData({
				level: props.selectedData.level.filter((l) => l !== level),
			});
		} else {
			props.setSelectedData({
				level: [...props.selectedData.level, level],
			});
		}
	};

	const renderFilter = (type, className) => {
		return (
			<FormControlLabel
				labelClassName={`control-label-checkbox control-label-${className}`}
				label={t(`filters.exams.level.levels.${type}`)}
				value={type}
				checked={props.selectedData.level.includes(type)}
				onChange={() => setSelectedType(type)}
				Control={<Checkbox />}
			/>
		);
	};

	const renderFilters = () => {
		return (
			<div className="flex flex-col gap-16">
				{renderFilter("hard", "error")}
				{renderFilter("medium", "warning")}
				{renderFilter("easy", "success")}
			</div>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.level.title")}
			renderFilterDetails={renderFilters}
			selected={props.selectedData.level.length}
			hint={t("filters.exams.level.filterHint")}
		/>
	);
}
